export default __webpack_public_path__ + "static/media/box.6276a8fa.svg";